<list-view *ngIf="listeAxe6" [liste]="listeAxe6"></list-view>
<floating-button [listeActions]="listeActions"></floating-button>